import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";
import SignatureModal from "Components/Modals/SignatureModal";
import { FormikProps } from "formik";
import { QuoteInvoiceValues } from "pages/Settings/Cards/PaymentsAndInvoicing";
import { useState } from "react";
import { Col, Label, Popover, PopoverBody, Row } from "reactstrap";

interface PaymentInfoProps {
  validation: FormikProps<QuoteInvoiceValues>;
  navigateToSignature?: boolean;
  loading?: boolean;
}

const QuoteInvoiceSetting = ({
  validation,
  navigateToSignature,
  loading,
}: PaymentInfoProps) => {
  const [showTooltip, setShowTooltip] = useState<{
    tnc: boolean;
    message: boolean;
    signature: boolean;
  }>({
    tnc: false,
    message: false,
    signature: false,
  });
  const [isSignatureModal, setIsSignatureModal] = useState<boolean>(
    navigateToSignature || false
  );

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
        }}
        action="#"
      >
        <Row>
          <Col md="12" className="mt-4">
            <CustomInput
              label="Terms & Conditions"
              placeholder="Enter terms and conditions"
              type="textarea"
              name="tnc"
              value={validation.values.tnc}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              touched={validation.touched.tnc}
              error={validation.errors.tnc}
              isTooltip
              tooltipMessage="Add standard terms that will appear at the bottom of every quote and invoice, for example, payment terms, validity period, or service conditions."
            />

            <CustomInput
              label="Footer Message"
              placeholder="Enter message"
              type="text"
              name="message"
              value={validation.values.message}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              touched={validation.touched.message}
              error={validation.errors.message}
              isTooltip
              tooltipMessage="Add a short note or thank-you message shown at the bottom of your quotes and invoices,"
            />

            <div className="d-flex gap-1 align-content-center flex-row">
              <Label className="font-primary fw-normal fs-14 text-black2D d-flex">
                Signature
                <>
                  <i
                    className="ri-error-warning-line text-black2D ms-1 btn-press-effect"
                    style={{ fontSize: 18 }}
                    onClick={() => {
                      setShowTooltip((prev) => ({
                        ...prev,
                        signature: !prev?.signature,
                      }));
                    }}
                    id="signature"
                  />
                  <Popover
                    placement="auto"
                    isOpen={showTooltip?.signature}
                    target="signature"
                    toggle={() => {
                      setShowTooltip((prev) => ({
                        ...prev,
                        signature: !prev?.signature,
                      }));
                    }}
                    trigger="legacy"
                    popperClassName="br-10 p-2"
                    innerClassName="p-0 m-0"
                  >
                    <PopoverBody className="bg-white font-primary fs-16 fw-normal text-black2D ">
                      Your signature will appear on all quotes and invoices.
                    </PopoverBody>
                  </Popover>
                </>
              </Label>
            </div>
            <div
              className="signature-container"
              onClick={() => {
                setIsSignatureModal(true);
              }}
            >
              {validation.values.signature ? (
                <img
                  src={validation.values.signature}
                  alt="Signature"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <span className="text-muted fs-12">Click to add signature</span>
              )}
            </div>

            <Col md="12" className="mt-4 pt-2">
              <CustomButton
                text="Save Changes"
                type="submit"
                className="bg-primary br-7"
                loading={loading}
              />
            </Col>
          </Col>
        </Row>
      </form>
      <SignatureModal
        isOpen={isSignatureModal}
        onClose={() => {
          setIsSignatureModal(false);
        }}
        onSave={(sign) => {
          validation.setFieldValue("signature", sign);
          setIsSignatureModal(false);
        }}
      />
    </>
  );
};

export default QuoteInvoiceSetting;
